import I18n from 'I18n';
// @ts-expect-error Untyped
import { useSearchParam } from '../../hooks/searchParamHooks';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped
import useLanguageRequested from '../../hooks/useLanguageRequests';
import UsageTracker from '../../utils/UsageTracker';
import { theme } from 'academy-common-lib/utils/Styling';
import { FilterItems } from './FilterItems';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MobileFilterSingleSelect = ({
  defaultItem,
  trackId,
  lessonId,
  allowList,
  filterType,
  onSelect,
  buttonStyle,
  bypassSearchParamUpdate
}) => {
  const options = FilterItems[filterType] || [];
  const [__, changeHandler] = useSearchParam(filterType);
  const allowListLL = allowList && allowList.map(a => a.toLowerCase());
  return /*#__PURE__*/_jsx(_Fragment, {
    children: options.map(option => {
      const disabled = allowListLL && !allowListLL.includes(option.toLowerCase());

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [languageRequested, setLanguageRequested] = useLanguageRequested({
        trackId,
        lessonId,
        language: option
      });
      return /*#__PURE__*/_jsxs(UIFlex, {
        onClick: () => {
          if (!disabled) {
            if (onSelect) onSelect(option);
            if (!bypassSearchParamUpdate) changeHandler(option);
            UsageTracker.track('filterInteraction', {
              action: 'filter-selected',
              value: option,
              key: 'language-switcher',
              defaultValue: defaultItem
            });
          }
        },
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: disabled,
          style: Object.assign({
            color: disabled ? theme.colors.BATTLESHIP : undefined
          }, buttonStyle),
          use: "unstyled",
          children: filterType === 'language' ? LanguageNames[option.toLowerCase()] : I18n.text(`learningCenter.topFilters.${filterType}.${option}`)
        }), disabled && (trackId || lessonId) && /*#__PURE__*/_jsx(UIButton, {
          disabled: languageRequested,
          onClick: setLanguageRequested,
          style: Object.assign({
            overflow: 'visible',
            padding: '3px',
            width: 'auto'
          }, buttonStyle),
          use: "transparent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.button`
          })
        })]
      }, option);
    })
  });
};
export default MobileFilterSingleSelect;